import { Check, X } from 'lucide-react';

import { Button } from '@/_components';

import { useCompetitorFormContext } from '../../form-context';
import type { CompetitorQuerySchema } from '../../schemas';

export function FriendlyStatus({
  isPending,
  onUpdate,
}: {
  isPending: boolean;
  onUpdate: (value: Pick<CompetitorQuerySchema, 'behavior'>, msg: string) => void;
}) {
  const form = useCompetitorFormContext();

  const [behavior] = form.watch(['behavior']);

  const isFriendly = behavior === 'friendly';

  const handleBehaviorCtrl = () => {
    const newOption = isFriendly ? null : 'friendly';
    form.setValue('behavior', newOption);
    onUpdate({ behavior: newOption }, 'Friendship status has been updated successfully');
  };

  return (
    <Button
      as="link"
      className="justify-start"
      disabled={isPending}
      size="xs"
      onClick={handleBehaviorCtrl}
      icon={isFriendly ? Check : X}
      iconClassName={isFriendly ? 'text-success' : 'text-error'}
      aria-label="Toggle Behavior"
    >
      {isFriendly ? 'Friendly' : 'Not Friendly'}
    </Button>
  );
}
